// used as a global event bus for an easy exchange of events between our different vue instances (header, modal, app)
// thin wrapper around event functions is simply here to provide some transparency on how and why this actually works
import Vue from 'vue'

const VueEvent = new Vue()

export default {
  emit(eventName, eventData) {
    VueEvent.$emit(eventName, eventData)
  },
  on(eventName, fun) {
    VueEvent.$on(eventName, fun)
  },
  off(eventName, fun) {
    VueEvent.$off(eventName, fun)
  }
}
